import { Video } from '@/lib/types';
import Link from 'next/link';

interface VideoCardProps {
  video: Video;
  large?: boolean;
  light?: boolean;
}

export default function VideoCard({ video, large, light }: VideoCardProps) {
  const isClassName = video.imageBg?.startsWith('bg-');
  const imageStyle = !isClassName ? { backgroundImage: `url(${video.imageBg})` } : {};
  const imageClass = `${isClassName ? video.imageBg : 'bg-gray-100'} bg-cover bg-center bg-no-repeat`;

  return (
    <Link href={`/video/${video.id}`} className="group cursor-pointer transition-opacity duration-150 hover:opacity-80 block">
      <div 
        className={`relative ${imageClass} ${large ? 'aspect-[16/10]' : 'aspect-video'} w-full bg-[#1A1A1A]`}
        style={imageStyle}
      >
        {/* Play button */}
        <button className="absolute inset-0 flex items-center justify-center" aria-label="Play video">
          <div className={`${large ? 'w-[64px] h-[64px]' : 'w-11 h-11'} circle-avatar border-[3px] border-white/90 bg-black/40 hover:bg-[#C8102E] hover:border-[#C8102E] transition-all duration-200 flex items-center justify-center`}>
            <svg
              viewBox="0 0 24 24"
              fill="white"
              className={large ? 'w-6 h-6 ml-1' : 'w-4 h-4 ml-0.5'}
            >
              <polygon points="5,3 19,12 5,21" />
            </svg>
          </div>
        </button>
        {/* Duration badge */}
        <span className="absolute bottom-2 right-2 bg-black/80 text-white font-['IBM_Plex_Sans',system-ui,sans-serif] text-[11px] px-1.5 py-0.5">
          {video.duration}
        </span>
        {/* Live badge */}
        {video.isLive && (
          <span className="absolute top-2 left-2 bg-[#C8102E] text-white font-['IBM_Plex_Sans',system-ui,sans-serif] font-bold text-[10px] tracking-[0.1em] uppercase px-1.5 py-0.5 animate-live-pulse">
            LIVE
          </span>
        )}
      </div>
      <div className="mt-2">
        <span className="font-['IBM_Plex_Sans',system-ui,sans-serif] font-bold text-[10px] tracking-[0.1em] uppercase text-[#C8102E] mb-1 block">
          {video.category}
        </span>
        <h4 className={`font-['IBM_Plex_Sans',system-ui,sans-serif] font-semibold text-[14px] leading-[1.35] ${light ? 'text-white' : 'text-[#0D0D0D]'} group-hover:text-[#C8102E] transition-colors`}>
          {video.title}
        </h4>
      </div>
    </Link>
  );
}
